import { render } from "./LinkBanner.vue?vue&type=template&id=1d13a4d8&scoped=true"
import script from "./LinkBanner.vue?vue&type=script&lang=js"
export * from "./LinkBanner.vue?vue&type=script&lang=js"

import "./LinkBanner.vue?vue&type=style&index=0&id=1d13a4d8&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d13a4d8"]])

export default __exports__